// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"de5e1521","337":"08529b31","455":"cd06a3c9"}[chunkId] + ".chunk.js";
};